// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__12_u6","alert":"SettungsInbox_alert__3ylYp"};